// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__xEsrA","header":"ReportDetails_header__zNM6U","title":"ReportDetails_title__3k15m","left":"ReportDetails_left__2_HwU"};